module.exports = {
  createRequire: () => () => null,
};
